export default __webpack_public_path__ + "static/media/image.evesys-technologies.a2bbc199.png";